// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccessibilityRouteImport } from './routes/accessibility'
import { Route as ColorChartRouteImport } from './routes/color-chart'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ServiceAreaRouteImport } from './routes/service-area'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as EpoxyFlooringCityRouteImport } from './routes/epoxy-flooring.$city'
import { Route as UsageIndexRouteImport } from './routes/usage.index'
import { Route as UsageCategoryIndexRouteImport } from './routes/usage.$category.index'
import { Route as UsageCategoryItemRouteImport } from './routes/usage.$category.$item'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccessibilityRoute = AccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => rootRouteImport
          })
const ColorChartRoute = ColorChartRouteImport.update({
            id: '/color-chart',path: '/color-chart',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ServiceAreaRoute = ServiceAreaRouteImport.update({
            id: '/service-area',path: '/service-area',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const EpoxyFlooringCityRoute = EpoxyFlooringCityRouteImport.update({
            id: '/epoxy-flooring/$city',path: '/epoxy-flooring/$city',getParentRoute: () => rootRouteImport
          })
const UsageIndexRoute = UsageIndexRouteImport.update({
            id: '/usage/',path: '/usage/',getParentRoute: () => rootRouteImport
          })
const UsageCategoryIndexRoute = UsageCategoryIndexRouteImport.update({
            id: '/usage/$category/',path: '/usage/$category/',getParentRoute: () => rootRouteImport
          })
const UsageCategoryItemRoute = UsageCategoryItemRouteImport.update({
            id: '/usage/$category/$item',path: '/usage/$category/$item',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccessibilityRoute: AccessibilityRoute,ColorChartRoute: ColorChartRoute,ContactRoute: ContactRoute,PrivacyRoute: PrivacyRoute,ServiceAreaRoute: ServiceAreaRoute,ServicesRoute: ServicesRoute,TermsRoute: TermsRoute,BlogSlugRoute: BlogSlugRoute,EpoxyFlooringCityRoute: EpoxyFlooringCityRoute,BlogIndexRoute: BlogIndexRoute,UsageIndexRoute: UsageIndexRoute,UsageCategoryItemRoute: UsageCategoryItemRoute,UsageCategoryIndexRoute: UsageCategoryIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)